module.exports = __webpack_public_path__ + "static/img/14000008.606ba030.png";